// extracted by mini-css-extract-plugin
module.exports = {"why-shopini":"styles_why-shopini__1t5oo","list":"styles_list__2RxJQ","title":"styles_title__odP_W"};